export function isAnyModalOpen() {
  return (
    document.getElementsByClassName("le-modal").length > 0 || document.getElementsByClassName("modal-open").length > 0
  );
}
